/* unplugin-vue-components disabled */import { render } from "./PdpAgreementScreen.vue?vue&type=template&id=6caee802&scoped=true&ts=true"
import script from "./PdpAgreementScreen.vue?vue&type=script&lang=ts"
export * from "./PdpAgreementScreen.vue?vue&type=script&lang=ts"

import "./PdpAgreementScreen.vue?vue&type=style&index=0&id=6caee802&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6caee802"]])

export default __exports__